import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FileOption = (props) => {
  const { innerProps, data: { label } } = props;

  return (
    <div {...innerProps} className="entity">
      <FontAwesomeIcon
        className="mr-4"
        icon="file-csv"
        pull="left"
        size="lg"
      />
      {label}
    </div>
  );
};

FileOption.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired
  }).isRequired,
  innerProps: PropTypes.object
};

export default FileOption;
